export const SERVICE_TYPE:any = {
    '1 Compartment': 'info_trtmt_tank',
    '2 Compartment': 'info_trtmt_tank',
    '1 Compartment Grey': 'info_trtmt_tank',
    '2 Compartment Grey': 'info_trtmt_tank',
    'HOOT': 'info_trtmt_tank',
    'Pump': 'info_pump_tank',
    'Vault': 'info_pump_tank',
    'Peat Moss Poly': 'info_peat_moss',
    'Peat Moss concrete': 'info_peat_moss'
    
  };